<div class="main-tab-title-box">
  <mat-card-title class="main-title">Statistics</mat-card-title>
  <div>
    <analysis-options></analysis-options>
  </div>
</div>
<div *ngIf="loaderActive" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysis will begin after you finish typing</div>
</div>
<div *ngIf="loaderActive2 && !this.loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing and Saving</div>
</div>
<div *ngIf="loaderActiveFirstProject" class="div_loader_pag">
  <div  id="div_loader_pag">
    <div  class="loader_pag"></div>
  </div>
  <div class="main-box-title-12">Analysing...</div>
</div>
<mat-card-content>
  <span class="main-box-title-14">Click on the "<img class="edit-icon2" src="./assets/images/project-icon.svg">" icon to amend a statistic, and click on a statistic with the  "<img class="eye-icon eye-text" src="./assets/images/eye-icon.svg">" icon to highlight it in your text</span>
  
  <div class="horizontal-box" style="margin-top: 10px;">
    <div style="display: flex;">
      <img #eyeIcon class="eye-icon" *ngIf="!hideEyeIconsForSafari1561" src="./assets/images/eye-icon.svg" (click)="!(isButtonDisabled() || statistics.sentenceCount === 0) && toggleEyeIcon($event)"  [ngClass]="{
       'disabled-button': isButtonDisabled() || statistics.sentenceCount === 0
     }">
      <div class="main-box-title-14"> Sentence count</div>
    </div>
    <div class="main-box-value-16-bold" *ngIf="!isEditing_Sentence" >{{statistics.sentenceCount}}<img class="edit-icon" (click)="!isButtonDisabled() && editValue_Sentence()" src="./assets/images/project-icon.svg" [ngClass]="{'disabled-button': isButtonDisabled()}"></div>
    <input *ngIf="isEditing_Sentence"  type="number" (input)="limitsSentence($event)" [(ngModel)]="statistics.sentenceCount" (blur)="saveValue_Sentence()" (keypress)="onKeyPressSentence($event)" class="editable-input"/>
  </div>

  <div class="horizontal-box">
    <div style="display: flex;">
      <img  #eyeIcon class="eye-icon" *ngIf="!hideEyeIconsForSafari1561" src="./assets/images/eye-icon.svg" (click)="!isButtonDisabled() && toggleEyeTokens($event,this.statistics.wordCount_data)" [ngClass]="{'disabled-button': isButtonDisabled()}">
      <div class="main-box-title-14">Token count (similar to word count)  <div class="tooltip-container">
        <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
        <span class="tooltip-text2">
          Tokens are similar to words, but include punctuation and other elements.
        </span>
      </div>
      <span *ngIf="excludeDigits">, excluding numbers</span>
       
    </div>
    </div>
      <div class="main-box-value-16-bold" style="display: flex;" *ngIf="!isEditing_Word">{{statistics.wordCount}}<img class="edit-icon" (click)="!isButtonDisabled() && editValue_Word()" src="./assets/images/project-icon.svg" [ngClass]="{'disabled-button': isButtonDisabled()}"></div>
      <input *ngIf="isEditing_Word" type="number" (input)="limitsToken($event)" [(ngModel)]="statistics.wordCount" (blur)="saveValue_Word()" (keypress)="onKeyPressWord($event)" class="editable-input"/>
  </div>

  <div class="horizontal-box">
    <div style="display: flex;">
      <img #eyeIcon class="eye-icon" *ngIf="!hideEyeIconsForSafari1561" src="./assets/images/eye-icon.svg" (click)="!isButtonDisabled() && toggleEyeUniqueTokens($event,this.statistics.uniqueWordCount_data)" [ngClass]="{'disabled-button': isButtonDisabled()}">
      <div class="main-box-title-14">Types (or unique tokens)<span *ngIf="excludeDigits">, excluding numbers</span></div>
    </div>
    <div class="main-box-value-16-bold" style="display: flex;" *ngIf="!isEditing_Unique">{{statistics.uniqueWordCount}}<img class="edit-icon" (click)="!isButtonDisabled() && editValue_Unique()" src="./assets/images/project-icon.svg" [ngClass]="{'disabled-button': isButtonDisabled()}"></div>
    <input *ngIf="isEditing_Unique" type="number" (input)="limitsUnique($event)" [(ngModel)]="statistics.uniqueWordCount" (blur)="saveValue_Unique()" (keypress)="onKeyPressUnique($event)" class="editable-input"/>   
  </div>

  <ng-container *ngIf="checked">
    <div class="horizontal-box">
      <div class="main-box-title-14" style="padding-left:33px">Average sentence length</div>
      <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.averageSentenceLength}}</div>
    </div>
    <div class="horizontal-box">
      <div class="main-box-title-14" style="padding-left:33px">Type/token ratio
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">This is calculated by dividing the unique words by the total number of words, giving you a sense of how many unique words are used as a proportion of the total words.</span>
        </div>
      </div>
      <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.uniqueWordsRatio}}</div>
    </div>
  </ng-container>

  <div class="horizontal-box" *ngIf="!excludeDigits">
    <div #eyeIcon class="main-box-title-14"><div class="tooltip-container">
  <img class="eye-icon" 
       *ngIf="!hideEyeIconsForSafari1561" 
       src="./assets/images/eye-icon.svg" 
       (click)="!(isButtonDisabled() || statistics.numberCount === 0) && toggleEyeIconNumbers($event)" 
       [ngClass]="{
         'disabled-button': isButtonDisabled() || statistics.numberCount === 0
       }">
  
  <!-- Tooltip solo aparece si está deshabilitado -->
  <span class="tooltip-text" 
        *ngIf="statistics.numberCount === 0">
    In this text, there are no words to show in this category.
  </span>
</div>

         Number count</div>
    <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.numberCount}}/{{statistics.totalDigits}} total digits</div>
  </div>

  <div class="horizontal-box">
    <div class="main-box-title-14" style="padding-left:33px">Syllable count</div>
    <div class="main-box-value-16-bold" *ngIf="!isEditing_Syllable">{{statistics.syllableCount}}<img class="edit-icon" (click)="!isButtonDisabled() && editValue_Syllable()" src="./assets/images/project-icon.svg" [ngClass]="{'disabled-button': isButtonDisabled()}"></div>
    <input *ngIf="isEditing_Syllable"  type="number" (input)="limitsSyllable($event)" [(ngModel)]="statistics.syllableCount" (blur)="saveValue_Syllable()" (keypress)="onKeyPressSyllable($event)" class="editable-input"/>
  </div>

  <ng-container *ngIf="checked">
    <div class="horizontal-box">
      <div style="display: flex;"> 
      <div style="display: flex;" class="tooltip-container">
        <img #eyeIcon class="eye-icon" 
            *ngIf="!hideEyeIconsForSafari1561" 
            src="./assets/images/eye-icon.svg" 
            (click)="!(isButtonDisabled() || statistics.wordsWithMoreThan2Syllables === 0) && toggleEyeIcon2sylla($event, statistics.wordsWithMoreThan2Syllables_data)"  
            [ngClass]="{
              'disabled-button': isButtonDisabled() || statistics.wordsWithMoreThan2Syllables === 0
            }">

        <!-- Tooltip cuando está deshabilitado -->
        <span class="tooltip-text" 
              *ngIf="statistics.wordsWithMoreThan2Syllables === 0">
          In this text, there are no words to show in this category.
        </span>

        
      </div>
      <div class="main-box-title-14">Words with more than 2 syllables</div>
      </div>

      <div class="main-box-value-16-bold" style="padding-right:24px;">
        {{statistics.wordsWithMoreThan2Syllables}}
      </div>
    </div>


    <div class="horizontal-box">
      <div class="main-box-title-14" style="padding-left:33px;">Words with more than 2 syllabes - Percentage</div>
      <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.wordsWithMoreThan2SyllablesPercentage}}</div>
    </div>

    <div class="horizontal-box">
      <div class="main-box-title-14" style="padding-left:33px;"> Average syllables per sentence</div>
      <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.averageSyllablesPerSentence}}</div>
    </div>

    <div class="horizontal-box">
      <div class="main-box-title-14" style="padding-left:33px;">Average syllables per word</div>
      <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.averageSyllablesPerWord}}</div>
    </div>

    <div class="horizontal-box">
      <div class="main-box-title-14" style="padding-left:33px">Syllables per 100 words</div>
      <div class="main-box-value-16-bold" style="padding-right:24px;">{{statistics.syllablesPer100Words}}</div>
    </div>

    <div class="scorecard-title" style="font: 18px;" *ngIf="excludeDigits && listaDeNumeros.length > 0">
      Excluded Digits
    </div>
    <div class="little-title" style="font: 14px;" *ngIf="excludeDigits && listaDeNumeros.length > 0">
      {{ listaDeNumeros.join(', ') }}
    </div>

  </ng-container>
  <ng-container *ngIf="!checked">
    <div class="text-box-bottom-simple-mode">
      <div class="line-box-bottom-simple-mode">
        <div class="bottom-text-line-simple-mode"></div>
      </div>
      <span class="main-box-title-14">To see full statistics, switch to “Advanced Mode”.</span>
    </div>
  </ng-container>

</mat-card-content>